export default __webpack_public_path__ + "static/gregsandell-resume-threePage.doc";